import cn from 'classnames';
import Assets from 'assets/icons';
import { Button, Dropdown, MenuProps } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { setIsResearchModalOpen } from 'store/slices/researchSlice';
import { exportReportExcel, exportReportPdf } from 'helpers/reportExportHelpers';
import classes from './ControlGroups.module.scss';

const ControlReport = () => {
  const { reportDocumentData, reportDocumentID, reportDocumentRoomID, reportDocumentName, isReportDocumentHasNoToken } = useAppSelector((state) => state.research);
  const { messageApi } = useAppSelector((state) => state.windowState);

  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  
  const openResearchModal = () => {
    dispatch(setIsResearchModalOpen(true));
  };

  const onExportExcel = async () => {
    if (reportDocumentData && reportDocumentID && reportDocumentName) {
      await exportReportExcel(
        reportDocumentData,
        reportDocumentName,
        reportDocumentID,
        reportDocumentRoomID,
        t,
        messageApi,
      );
    }
  };

  const onExportPdf = async () => {
    if (reportDocumentData && reportDocumentID && reportDocumentName) {
      await exportReportPdf(
        reportDocumentData,
        reportDocumentName,
        reportDocumentID,
        reportDocumentRoomID,
        t,
        messageApi
      );
    }
  };
  
  const reportItems: MenuProps['items'] = [
    {
      label: (
        <span className={cn(classes.spanItem, classes.resetButton)}>
          <ReloadOutlined /> {t('Report.tabs.extra')}
        </span>
      ),
      onClick: openResearchModal,
      className: classes.menuItem,
      key: 'uploadReport',
    },
  ];

  reportItems.push({
    type: 'divider',
    className: classes.divider,
  });
  reportItems.push({
    label: (
      <span className={classes.spanItem}>
        <Assets.DownloadIcon /> {t('Report.report.download')} PDF
      </span>
    ),
    onClick: onExportPdf,
    className: classes.menuItem,
    key: 'exportPdf',
    disabled: isReportDocumentHasNoToken,
  });

  reportItems.push({
    type: 'divider',
    className: classes.divider,
  });

  reportItems.push({
    label: (
      <span className={classes.spanItem}>
        <Assets.DownloadIcon /> {t('Report.report.download')} XLSX
      </span>
    ),
    onClick: onExportExcel,
    className: classes.menuItem,
    key: 'exportExcel',
    disabled: isReportDocumentHasNoToken,
  });

  return (
    <div className={classes.iconsGroup}>
      <Dropdown
        menu={{ items: reportItems }}
        trigger={['click']}
        classNames={{ root: classes.addMenu }}
      >
        <Button
          className={classes.buttonWithIcon}
          type='text'
          icon={<Assets.VerticalIcon />}
        />
      </Dropdown>
    </div>
  );
};

export default ControlReport;
